import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, DatePicker, Select } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    deal_store_id: string | undefined,
    customer_name: string | undefined,
    customer_phone: string | undefined,
    serviceDate: any,
    service_type: number | undefined,
    service_status: number | undefined,
    nursing_name: string | undefined,
    in_out: number | undefined,
    belong_store_id: string | undefined,
    coperation_id: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number
}

export default function Coperation() {

    let fetchOtherParamsTmpl: fetchParams = {
        deal_store_id: undefined,
        customer_name: undefined,
        customer_phone: undefined,
        serviceDate: undefined,
        service_type: undefined,
        service_status: undefined,
        nursing_name: undefined,
        in_out: undefined,
        belong_store_id: undefined,
        coperation_id: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0
    })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [data, setData] = useState<any>([])

    const [coperationList, setCoperationList] = useState<any>([])

    // 页面权限
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    useEffect(() => {
        // 查看合作商列表
        axiosTable.get("/yuesao_center/global/coperation_list", {

        }).then((response: any) => {
            if (response) {
                setCoperationList(response)
            }
        })
    }, [])
    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleDate = (param: any, attr: string, realDateParams: string[]) => {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        // 处理日期参数
        handleDate(params, 'serviceDate', ['service_start_date', 'service_end_date'])

        axiosTable.get('/yuesao_center/customer/nursing_work/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)
        })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }

        let params: any = { ...fetchOtherParams }
        // 处理日期参数
        handleDate(params, 'serviceDate', ['service_start_date', 'service_end_date'])

        baseAxiosComplete('/yuesao_center/customer/nursing_work/export', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 客户管理 -> 客户上单管理 */}
        <BreadCrumb position={['月嫂中心', '客户上单管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="签单门店" value={fetchOtherParams.deal_store_id} onChange={(value: string) => { handleChange(value, 'deal_store_id') }} />
                </div>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="客户姓名" value={fetchOtherParams.customer_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="客户手机号" value={fetchOtherParams.customer_phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_phone') }} />

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: '250px' }} className="fl" placeholder={["服务开始日期", "服务结束日期"]} value={fetchOtherParams.serviceDate} onChange={(value: any) => { handleChange(value, 'serviceDate') }} />
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="服务类型" value={fetchOtherParams.service_type} onChange={(value: number) => { handleChange(value, 'service_type') }}>
                    <Option value="1">月子会所</Option>
                    <Option value="2">月嫂到府</Option>
                </Select>
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="服务状态" value={fetchOtherParams.service_status} onChange={(value: number) => { handleChange(value, 'service_status') }} >
                    <Option value="1">已预订</Option>
                    <Option value="2">服务中</Option>
                    <Option value="3">已下单</Option>
                </Select>

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工名称" value={fetchOtherParams.nursing_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_name') }} />
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="员工类型" value={fetchOtherParams.in_out} onChange={(value: number) => { handleChange(value, 'in_out') }}  >
                    <Option value="1">内部员工</Option>
                    <Option value="2">合作商员工</Option>
                </Select>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="员工门店" value={fetchOtherParams.belong_store_id} onChange={(value: string) => { handleChange(value, 'belong_store_id') }} />
                </div>
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 200 }} placeholder="员工合作商" value={fetchOtherParams.coperation_id} onChange={(value: string) => { handleChange(value, 'coperation_id') }}  >
                    {coperationList.map((item: any) => {
                        return <Option value={item.coperation_id} key={item.coperation_id}>{item.coperation_name}</Option>
                    })}
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column fixed title="客户姓名" dataIndex="customer_name" key="customer_name" />
                <Column fixed title="客户手机号" dataIndex="customer_phone" key="customer_phone" />

                <Column fixed title="员工名称" dataIndex="belong_nursing_name" key="belong_nursing_name" />
                <Column fixed title="员工手机号" dataIndex="belong_nursing_phone" key="belong_nursing_phone" />
                <Column title="员工类型" dataIndex="in_out_desc" key="in_out_desc" />
                <Column title="员工门店" dataIndex="belong_store_name" key="belong_store_name" />
                <Column title="员工合作商" dataIndex="coperation_name" key="coperation_name" />

                <Column title="护理模式" dataIndex="nursing_care_type_desc" key="nursing_care_type_desc" />
                <Column title="服务类型" dataIndex="service_type_desc" key="service_type_desc" />
                <Column title="服务开始日期" dataIndex="service_start_date" key="service_start_date" />
                <Column title="服务结束日期" dataIndex="service_end_date" key="service_end_date" />
                <Column title="服务天数" dataIndex="service_days" key="service_days" />
                <Column title="服务状态" dataIndex="service_status_desc" key="service_status_desc" />
                <Column title="服务地址" dataIndex="service_address" key="service_address" />
            </Table>
        </div>
    </div>)
}